import React from 'react';
import { motion } from 'framer-motion';
import { MousePointerClick, MessageCircle, CalendarDays } from 'lucide-react';
const steps = [{
  icon: MousePointerClick,
  title: 'Tocás el botón',
  desc: 'Hacé clic en cualquiera de los botones verdes de esta página.'
}, {
  icon: MessageCircle,
  title: 'Entrás al grupo de WhatsApp',
  desc: 'Te unís a nuestra comunidad gratuita y silenciosa.'
}, {
  icon: CalendarDays,
  title: 'Ves los horarios y accedés',
  desc: 'Ahí mismo te pasamos el link y la hora de la charla en vivo.'
}];
export function HowItWorksSection() {
  return <section className="py-24 px-4 bg-darkCard relative overflow-hidden" data-id="element-61">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-62">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-display text-3xl md:text-4xl font-bold text-center mb-20 text-white" data-id="element-63">
          ¿Cómo funciona?
        </motion.h2>

        <div className="relative" data-id="element-64">
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-white/10" data-id="element-65" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-66">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="relative flex flex-col items-center text-center" data-id="element-67">
                <div className="w-24 h-24 bg-darkCard rounded-full border-2 border-whatsapp flex items-center justify-center mb-6 relative z-10 shadow-[0_0_20px_rgba(37,211,102,0.15)]" data-id="element-68">
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-whatsapp text-white font-bold rounded-full flex items-center justify-center text-sm" data-id="element-69">
                    {index + 1}
                  </div>
                  <step.icon className="w-10 h-10 text-whatsapp" data-id="element-70" />
                </div>

                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-71">
                  {step.title}
                </h3>
                <p className="text-gray-400 font-medium max-w-[250px]" data-id="element-72">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}